<template>
  <form-page-template>
    <div class="uc-form">
      <h1 class="uc-form-header">{{ $t('setPassword.header') }}</h1>
      <div v-if="msg" class="alert alert-danger" role="alert">
        {{ msg }}
      </div>

      <form v-if="!showSuccess">
        <div class="uc-form-element">
          <label for="email">{{ $t('setPassword.emailLabel') }}</label>
          <input
            id="email"
            class="uc-form-text-input"
            type="email"
            :placeholder="$t('setPassword.emailPlaceholder')"
            v-model="credentials.email"
            required
            autofocus
          />
        </div>

        <div class="uc-form-element">
          <label for="password">
            {{ $t('setPassword.passwordLabel') }}
          </label>
          <input
            id="password"
            class="uc-form-text-input"
            type="password"
            :placeholder="$t('setPassword.passwordPlaceholder')"
            v-model="credentials.password"
            required
          />
          <div class="metadata">
            {{ $t('setPassword.passwordMetadata') }}
          </div>
        </div>

        <div class="uc-form-element">
          <label for="re-enter-password">
            {{ $t('setPassword.reEnterPasswordLabel') }}
          </label>
          <input
            id="re-enter-password"
            class="uc-form-text-input"
            type="password"
            :placeholder="$t('setPassword.reEnterPasswordPlaceholder')"
            v-model="credentials.newpassword"
            required
          />
        </div>

        <button class="uc-form-button" type="submit" @click.prevent="submit()">
          {{ $t('setPassword.resetButton') }}
        </button>
        <RecaptchaCaption />

        <loader v-if="isResettingPassword" overlay />
      </form>

      <div v-else-if="showSuccess" class="success-message">
        <p>{{ $t('setPassword.successMessage') }}</p>
        <large-button primary routeTo="/">{{ redirectText }}</large-button>
      </div>
    </div>
  </form-page-template>
</template>

<script>
import { mapState } from 'vuex'

import AuthService from '@/services/AuthService'
import FormPageTemplate from '@/components/FormPageTemplate.vue'
import LargeButton from '@/components/LargeButton.vue'
import Loader from '@/components/Loader.vue'
import LoggerService from '@/services/LoggerService'
import RecaptchaCaption from '@/components/recaptcha/RecaptchaCaption.vue'

export default {
  components: {
    RecaptchaCaption,
    FormPageTemplate,
    LargeButton,
    Loader,
  },
  props: {
    token: String,
  },
  created() {
    this.$store.dispatch('app/hideNavigation')
  },
  data() {
    return {
      msg: '',
      credentials: {
        token: '',
        email: '',
        password: '',
        newpassword: '',
      },
      isResettingPassword: false,
      showSuccess: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
    redirectText() {
      return this.user
        ? this.$root.$t('setPassword.redirectText.home')
        : this.$root.$t('setPassword.redirectText.login')
    },
  },
  methods: {
    submit() {
      this.isResettingPassword = true

      AuthService.confirmReset(this, {
        token: this.token,
        email: this.credentials.email,
        password: this.credentials.password,
        newpassword: this.credentials.newpassword,
      })
        .then(() => {
          this.isResettingPassword = false
          this.showSuccess = true
        })
        .catch(err => {
          this.isResettingPassword = false
          this.msg =
            err?.response?.data?.err ?? this.$root.$t('setPassword.error')
          if (err?.response?.status !== 422) {
            LoggerService.noticeError(err)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.success-message {
  @include flex-container(column, center, center);
  margin: auto 0;
  padding: 50px;
}
</style>
